module.exports = __webpack_public_path__ + "img/stock6.8b8e45e1.png";